import React, { useEffect, useState } from 'react';
import Focus from '../pages/focus';
import Pulse from '../pages/pulse';
import Trends from '../pages/trends';
import Nutrition from '../pages/nutrition';
import Performance from '../pages/performance';
import Research from '../pages/research';
import WorkoutPlan from '../pages/workouts';
import Prompts from '../pages/prompts';

const MainPage = () => {
  const [activeSection, setActiveSection] = useState(""); 
  
     
  useEffect(() => {
    const handleScroll = (hash) => {
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
  
    // Handle initial load with hash
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setActiveSection(hash);
      setTimeout(() => handleScroll(hash), 100);
    }
  
    // Handle hash changes
    const handleHashChange = () => {
      const newHash = window.location.hash.replace('#', '');
      setActiveSection(newHash);
      handleScroll(newHash);
    };
  
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div> 

      {activeSection === "" && (
        <>
          <div id="journey">
            <Focus />
          </div>
          <div id="pulse">
            <Pulse />
          </div>
          <div id="trends">
            <Trends />
          </div>
          <div id="nutrition">
            <Nutrition />
          </div>
          <div id="performance">
            <Performance />
          </div>
          <div id="research">
            <Research />
          </div>
          <div id="workouts">
            <WorkoutPlan />
          </div>
          <div id="prompts">
            <Prompts />
          </div>
        </>
      )}

      {/* Show the individual section based on hash */}
      {activeSection === "journey" && <Focus />}
      {activeSection === "pulse" && <Pulse />}
      {activeSection === "trends" && <Trends />}
      {activeSection === "nutrition" && <Nutrition />}
      {activeSection === "performance" && <Performance />}
      {activeSection === "research" && <Research />}
      {activeSection === "workouts" && <WorkoutPlan />}
      {activeSection === "prompts" && <Prompts />}
    </div>
    
  );
};

export default MainPage;





